module.exports = __webpack_public_path__ + "static/media/Pouť-97-korunovace1b.045fd930.jpg";